import { MEMBER_DATA_SOURCE } from '../../constants/memberConstants';
import {
  IBillHistoryResponse,
  IGovernmentProductDetails,
  IPaymentHistoryDetailsForActiveGov,
  IPaymentHistoryResponse,
} from '../../store/interface';
import utils from '../utils';

interface IHistoryHeaders {
  MEMBER_ID: string;
  MPP_ID: number;
  STATE_CODE: string;
  MID?: string;
  DATA_SOURCE?: MEMBER_DATA_SOURCE;
}
const { getUserSpecificAPIRoute } = utils;
const history = () => ({
  getPaymentHistory: (
    headers: IHistoryHeaders,
    userTypeCode: number,
    data: IPaymentHistoryDetailsForActiveGov,
  ) => {
    return new Promise<IPaymentHistoryResponse>((resolve, reject) => {
      utils
        .fetch(
          `${getUserSpecificAPIRoute(userTypeCode).history.getPaymentHistory}`,
          {
            method: 'POST',
            headers,
            data,
          },
        )
        .then((res: { response?: IPaymentHistoryResponse }) => {
          if (res && res.response && res.response.paymentHistoryList) {
            resolve(res.response);
          } else {
            reject();
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getBillingHistory: (
    headers: IHistoryHeaders,
    userTypeCode: number,
    data?: IGovernmentProductDetails,
  ) => {
    return new Promise<IBillHistoryResponse[]>((resolve, reject) => {
      utils
        .fetch(
          `${getUserSpecificAPIRoute(userTypeCode).history.getBillingHistory}`,
          {
            method: 'POST',
            headers,
            data,
          },
        )
        .then((res: { response?: IBillHistoryResponse[] }) => {
          if (res && res.response) {
            resolve(res.response);
          } else {
            reject();
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
});

export default history;
